import { user_image } from "@/constant/imagePath";
import { imageUrl } from "config/apiUrl";
import {
  IoCaretBackOutline,
  IoNotifications,
  IoNotificationsOutline,
} from "react-icons/io5";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Classes from "./AfterLoginHeader.module.css";

export const AfterLoginHeader = ({ header, drawerBtn }) => {
  const { user } = useSelector((state) => state?.authReducer);
  const { unReadNotificationCount } = useSelector(
    (state) => state.commonReducer
  );
  const path = useLocation().pathname;
  const navigate = useNavigate();

  return (
    <div className={Classes.loginHeader}>
      <div className={Classes.navbarContainer}>
        {drawerBtn && drawerBtn}
        <div className={Classes.mainHeader}>
          {false && (
            <div className={Classes.backBtn} onClick={() => navigate(-1)}>
              <IoCaretBackOutline />
            </div>
          )}
          {header && <h1 className={Classes.heading}>{header}</h1>}
        </div>

        <div
          className={Classes.notification_header}
          onClick={() => navigate("/notifications")}
        >
          {unReadNotificationCount > 0 && (
            <p>
              {unReadNotificationCount > 9 ? "9+" : unReadNotificationCount}
            </p>
          )}
          <IoNotifications color="var(--white-color)" size={25} />
        </div>
        <div className={Classes.profileContainer}>
          <div
            className={`${[Classes.profileImg]} `}
            onClick={() => navigate("/account-settings")}
          >
            <img
              src={user?.photo ? imageUrl(user?.photo) : user_image}
              alt="profile"
              width={45}
              height={45}
            />
          </div>
          <div className={Classes.profileInfo}>
            <p>{user?.name || "John Doe"}</p>
            <span>{user?.role || "Admin"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
